module.exports = __webpack_public_path__ + "img/local.b285a18f.png";